export enum BulkActionStatus {
    QUEUED = 'QUEUED',
    PROCESSING = 'PROCESSING',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED',
    VALIDATED = 'VALIDATED',
    VALIDATION_FAILED = 'VALIDATION_FAILED',
    CANCELLED = 'CANCELLED',
    UPDATE_REQUESTED = 'UPDATE_REQUESTED'
}
